export default {
  DEVICE_ISSUE_HEADING: `athenaTelehealth is having trouble with your devices`,
  DEVICE_ISSUE_INSTRUCTIONS: `Please check that your camera and microphone are turned on and that their cables are connected to your device. Then, click “Try Again” to start over.`,
};
